"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.superscriptStyle = exports.Fraction = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Fraction = styled_components_1.default.span ``;
const crossOutStyle = (0, styled_components_1.css) `
  color: ${({ theme }) => theme.colors.gray.s600};

  // @note(mlaigle): we cannot use text-decoration: line-through because the superscriptStyle is not always at the same font-size
  ::after {
    position: absolute;
    content: '';
    top: calc(50% - 1px);
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.gray.s600};
  }
`;
exports.superscriptStyle = (0, styled_components_1.css) `
  & > ${exports.Fraction} {
    font-size: 0.75em;
    margin-left: -${({ theme }) => theme.space.s025};
  }
`;
exports.Container = styled_components_1.default.span `
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  ${({ isCrossOut }) => isCrossOut && crossOutStyle};
  ${({ isSuperscript }) => isSuperscript && exports.superscriptStyle}
`;
